import { Field } from 'react-final-form';

import { InputNumericFormat as InputNumericFormatTHC } from '@motorway/mw-highway-code/alpha';

import { Label } from './FormHelpers';
import { getIntent, logOnFieldComplete, maxRequired } from './forms.helpers';

export const InputNumericFormat = ({ label, name, max }: { label: string; name: string; max?: number }) => {
  return (
    <section>
      <Field name={name} validate={(value: string) => maxRequired(value, max)}>
        {({ input, meta }) => (
          <InputNumericFormatTHC
            autoComplete="off"
            formProps={{
              input: {
                ...input,
                onBlur: logOnFieldComplete(meta, input.onBlur),
              },
            }}
            fullWidth
            id={name}
            label={Label(label)}
            prepend="£"
            max={max}
            showLabel
            intent={getIntent(meta)}
            maxLength={6}
          />
        )}
      </Field>
    </section>
  );
};
